var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDayCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 19,
    viewBox: "0 0 74 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55866 18.8L0.2 11.9705V0.2H73.8V11.9705L67.4413 18.8H52.0848H21.9152H6.55866Z",
    fill: "url(#paint0_linear_2994_2536)",
    stroke: "#FFB739",
    strokeWidth: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2994_2536",
    x1: 37,
    y1: 46.6213,
    x2: 37,
    y2: -51.4115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB739",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26253F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDayCurrent);
export default __webpack_public_path__ + "static/media/iconDayCurrent.a966598fafd499cd65d5d4e8b28d37a8.svg";
export { ForwardRef as ReactComponent };